module.exports = __webpack_public_path__ + "img/ico_payment_disabled.75cf8eec.png";